// extracted by mini-css-extract-plugin
export var date = "start-block-module--date--a02d5";
export var location = "start-block-module--location--2728b";